import Axios from "axios";
import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import styled from "styled-components";
import Dashboard from "../../layouts/Dashboard";
import List from "./Kanban/List";
import url from "../../services/url";
import CandidateModal from "./Kanban/CandidateModal";
import RSelect from "react-select";
import Loading from "../../components/Loading";
import { Else, If } from "react-condition";
import isConsultant from "../../services/isConsultant";

const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 240px);
  margin-left: -8px;
  margin-right: -8px;
`;

function Kanban() {
  const [search, setSearch] = useState("");
  const [candidate, setCandidate] = useState("");
  const [previousCandidate, setPreviousCandidate] = useState(null);
  const [nextCandidate, setNextCandidate] = useState(null);
  const [candidates, setCandidates] = useState({});
  const [lists, setLists] = useState({});
  const [listsOrder, setListsOrder] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalInterview, setModalInterview] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [homeIndex, setHomeIndex] = useState(null);
  const [positionFilter, setPositionFilter] = useState();
  const [locationFilter, setLocationFilter] = useState();
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    Axios.get(url("kanban"),{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }})
      .then(({ data }) => {
        setCandidates(data.candidates);
        setLists(data.lists);
        setIsLoading(false);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    setListsOrder(Object.keys(lists));
  }, [lists]);

  function onDragStart(start) {
    setHomeIndex(listsOrder.indexOf(start.source.droppableId));
  }

  function onDragEnd({ destination, source, draggableId }) {
    setHomeIndex(null);
    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    const start = lists[source.droppableId];
    const finish = lists[destination.droppableId];

    if (start === finish) {
      let newCandidates = Array.from(start.candidates);
      newCandidates.splice(source.index, 1);
      newCandidates.splice(destination.index, 0, draggableId);
      let newList = {
        ...start,
        candidates: newCandidates,
      };

      let newLists = {
        ...lists,
        [newList.id]: newList,
      };
      setLists(newLists);
      return;
    }

    let startCandidates = Array.from(start.candidates);
    startCandidates.splice(source.index, 1);
    const newStart = {
      ...start,
      candidates: startCandidates,
    };

    let finishCandidates = Array.from(finish.candidates);
    finishCandidates.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      candidates: finishCandidates,
    };

    const newLists = {
      ...lists,
      [newStart.id]: newStart,
      [newFinish.id]: newFinish,
    };
    setLists(newLists);
    Axios.put(url("kanban"), {
      lists: newLists,
    },{
      headers:{
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }})
      .then((res) => {})
      .catch(console.error);
    return;
  }

  function onOpenModal(candidate, previousCandidate = null, nextCandidate = null) {
    return () => {
      setCandidate(candidate);
      setPreviousCandidate(previousCandidate);
      setNextCandidate(nextCandidate);
      toggleModal();
    };
  }

  function onOpenModalInterview(event) {
    let candidate = event.target.getAttribute("candidate");
    setCandidate(candidate);
    toggleModalInterview();
  }

  function toggleModal() {
    if (modal === true) {
      setCandidate("");
    }
    setModal(!modal);
  }
  function toggleModalInterview() {
    if (modalInterview === true) {
      setCandidate("");
    }
    setModalInterview(!modalInterview);
  }

  function onClickClearFilters() {
    setLocationFilter();
    setPositionFilter();
  }

  function reactSelectOptionMap(list, key) {
    let temp = list.map((item) => {
      return item[key];
    });
    temp = [...new Set(temp)].map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    return temp;
  }

  let locationOptions = reactSelectOptionMap(Object.values(candidates), "location");
  let positionOptions = reactSelectOptionMap(Object.values(candidates), "job");

  return (
    <div>
    {!isConsultant() && <Dashboard title="Screening Board">
      <If test={isLoading === false}>
        <div className="row">
          <div className="col">
            <input type="search" className="form-control" placeholder="Search for candidates..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="col col-md-2">
            <button className="btn btn-primary btn-block" onClick={(e) => setShowFilters(!showFilters)}>
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>
          </div>
        </div>

        {showFilters ? (
          <div className="row my-3">
            <div className="col">
              <h6 className="text-primary">Location</h6>
              <RSelect options={locationOptions} onChange={(selected) => setLocationFilter(selected.value)} value={{ label: locationFilter, value: locationFilter }} />
            </div>
            <div className="col">
              <h6 className="text-primary">Position</h6>
              <RSelect options={positionOptions} onChange={(selected) => setPositionFilter(selected.value)} value={{ label: positionFilter, value: positionFilter }} />
            </div>
            <div className="col col-md-2 pt-4">
              <button className="mt-1 btn btn-primary btn-block" onClick={onClickClearFilters}>
                Clear Filters
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}

        <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
          <Container>
            {listsOrder.map((id, k) => {
              const list = lists[id];

              let isDropDisabled = false; // Uncomment to disable back drops k < homeIndex;
              if (!isDropDisabled) {
                if (k > homeIndex) {
                  if (k - homeIndex !== 1) {
                    isDropDisabled = true;
                  }
                }
              }

              return (
                <List
                  key={k}
                  list={list}
                  candidates={candidates}
                  onOpenModal={onOpenModal}
                  onOpenModalInterview={onOpenModalInterview}
                  isDropDisabled={isDropDisabled}
                  search={search}
                  filter={{
                    position: positionFilter,
                    location: locationFilter,
                  }}
                />
              );
            })}
          </Container>
        </DragDropContext>
        <CandidateModal
          modal={modal}
          toggleModal={toggleModal}
          candidate={candidate}
          setCandidate={setCandidate}
          nextCandidate={nextCandidate}
          previousCandidate={previousCandidate}
        />
        <Else>
          <Loading />
        </Else>
      </If>
    </Dashboard>}
    </div>
  );
}

export default Kanban;
